import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrigamiResponse, ServiceBase } from '../base/service.base';
import { getServerConfig } from '../../server-config';
import { AuthenticateOptions, AuthInfo, VerifyLoginPasswordOptions } from './authenticate.model';
import { ErrorCode, LogoffType } from '../../constants';
import { BuildProps } from '@app/origami-api/build-props';

@Injectable()
export class AuthenticateService extends ServiceBase {
  serviceUrl = 'AuthenticateService.svc';

  authenticate(options: AuthenticateOptions, silentErrorCodes?: ErrorCode[]): Observable<OrigamiResponse<AuthInfo>> {
    options.authenticationType = options.authenticationType || 'InternalUser';
    options.domain = options.domain || getServerConfig().domain;

    this.dropAllCache();
    return this.origamiPost('/Authenticate', options, null, silentErrorCodes, true);
  }

  logoff(
    logOffType: LogoffType = LogoffType.RegularLogOff,
    sessionToken?: string,
  ): Observable<OrigamiResponse<number>> {
    return this.origamiPost('/Logoff', { logOffType, sessionToken }, null, null, true);
  }

  // Checks if user is authenticated; also is used for the ping task to support the user session
  getAuthInfo(silentErrorCodes?: ErrorCode[]): Observable<OrigamiResponse<AuthInfo>> {
    return this.origamiPost('/GetAuthInfo', '', null, silentErrorCodes, true);
  }

  verifyLoginPassword(
    options: VerifyLoginPasswordOptions,
    silentErrorCodes?: ErrorCode[],
  ): Observable<OrigamiResponse<{ LockingTime: number }>> {
    return this.origamiPost('/VerifyLoginPassword', options, null, silentErrorCodes, true);
  }

  logOffByTimeout(): void {
    navigator.sendBeacon(BuildProps.origin + this.serviceUrl + '/LogOffByTimeout');
  }
}
